import _ from 'lodash'
import apiCommons from '@/api/commons'
import store from '@/store'

export default {
  data () {
    return {
      lmSuperPowerSelectV2BuilderUiOptions: [
        { id: 1, name: 'oficinas/secretarias/' },
        { id: 2, name: 'oficinas' },
        { id: 3, name: 'delegaciones/crm/dev/api/EstadoCivil' },
        { id: 4, name: 'delegaciones/crm/dev/api/TipoEvento' },
        { id: 5, name: 'delegaciones/crm/dev/api/Origen' },
        { id: 6, name: 'delegaciones/crm/dev/api/Nacionalidad' },
        { id: 7, name: 'delegaciones/crm/dev/api/Motivo' },
        { id: 8, name: 'delegaciones/crm/dev/api/SubMotivo' },
        { id: 9, name: 'delegaciones/crm/dev/api/Prioridad' },
        { id: 10, name: 'delegaciones/crm/dev/api/TipoCaso' },
        { id: 11, name: 'delegaciones/crm/dev/api/Secretaria' },
        { id: 12, name: 'delegaciones/crm/dev/api/Genero' },
        { id: 13, name: 'delegaciones/crm/dev/api/OrigenEvento' },
        { id: 14, name: 'delegaciones/crm/dev/api/TipoDocumento' }
      ],
      componentsOptions: {
        disabledOption: 'Seleccione una opción',
        content: []
      },
      generator: {
        selectorElementTypeOptions: {
          disabledOption: 'Seleccione una opción',
          content: [
            { value: 'LmTextInput', text: '🔤  Texto' },
            { value: 'LmNumberInput', text: '🔢  Número (String)' },
            { value: 'LmNumberInputV2', text: '🔢  Número (Number)' },
            { value: 'LmEmailInput', text: '📧  Email' },
            { value: 'LmTextArea', text: '📝  Área de texto' },
            { value: 'LmFormSeparator', text: '➖  Separador' },
            { value: 'LmFormEmptySpace', text: '↔ Espacio vacio' },
            { value: 'LmFormSubtitles', text: '📰  Subtítulo' },
            { value: 'LmSelect', text: '👆  Selector' },
            { value: 'LmRadio', text: '🔘  Radio' },
            { value: 'LmSuperPowerSelectV2', text: '💪  Selector avanzado' },
            { value: 'LmButton', text: '🔲 Botón' },
            { value: 'LmDate', text: '📆 Fecha' },
            { value: 'LmDateTime', text: '📆 🕑 Fecha y hora' },
            { value: 'LmEditor', text: '⌨ Editor' },
            { value: 'LmLeaFletMap', text: '🗺 Mapa' },
            { value: 'LmHtmlContent', text: '👨‍💻 Contenido Html' },
            { value: 'LmPassword', text: '🔑 Contraseña' },
            // { value: 'LmPortalTarget', text: '🚪 Portal' },
            { value: 'LmColorPicker', text: '🎨 Selector de Color' },
            // { value: 'LmComment', text: '🗣 Comentario para el desarrollador' },
            { value: 'LmCheckbox', text: '✅ Checkbox' },
            { value: 'LmRepeatFields', text: '🔄 Campos Repetitivos' },
            { value: 'LmUploadFiles', text: '📁 Carga de archivos' },
            { value: 'LmImportFromExcel', text: '📥 Importar desde un excel' },
            { value: 'LmTreeSelect', text: '🌳 Selector en árbol' }
          ]
        }
      }
    }
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    formComponentsOrigin: {
      type: String,
      default: '6144e6f8e11f102768619aee'
    },
    pathToRedirectOnSubmitOrCancel: {
      type: String,
      default: null
    }
  },
  methods: {
    removeFormElement (elementIndex) {
      delete this.form.validations[this.form.formElements[elementIndex].formObjectToSendToServerProperty]
      this.form.formElements.splice(elementIndex, 1)
    },
    getValidation (validatedField) {
      if (!this.form.validations) {
        this.form.validations = {}
      }
      return this.form.validations[validatedField]
    },
    buildSameAsOptions (formElements, currentIndex) {
      const options = [{ value: false, text: 'Ninguno' }]
      for (const index of formElements.keys()) {
        if (index !== currentIndex) {
          const formObjectToSendToServerProperty = formElements[index].formObjectToSendToServerProperty
          if (formObjectToSendToServerProperty) {
            options.push(
              {
                id: formElements[index].id,
                value: formObjectToSendToServerProperty,
                text: formObjectToSendToServerProperty,
                label: formElements[index].componentProps.label
              }
            )
          }
        }
      }
      return options
    },
    buildOptionsChildOf (formObjectToSendToServerProperty) {
      const allSuperPowers = this.form.formElements.filter(e => {
        if ((e.componentName === 'LmSuperPowerSelectV2' || e.componentName === 'LmTreeSelect') &&
          e.formObjectToSendToServerProperty !== formObjectToSendToServerProperty &&
          (e.componentProps.urlPathFromGetOptions || e.componentProps.pathToGetOptions)
        ) {
          return true
        }
      })
      const content = allSuperPowers.map(e => ({ value: e?.formObjectToSendToServerProperty, text: e?.componentProps?.label }))
      content.unshift({ value: null, text: 'Ninguno' })
      return { content }
    },
    generateId () {
      return Date.now() + Math.random()
    },
    nameFormatter (name) {
      return name.toLowerCase()
        .trim()
        .replaceAll(' ', '_')
        .replaceAll('á', 'a')
        .replaceAll('é', 'e')
        .replaceAll('í', 'i')
        .replaceAll('ó', 'o')
        .replaceAll('ú', 'u')
        .replaceAll('ñ', 'n')
        .replace(/\W+/g, '')
    },
    whatComponentBuilderUse (componentName) {
      let builderComponentToReturn = ''
      switch (componentName) {
        case 'LmTextInput':
        case 'LmNumberInput':
        case 'LmNumberInputV2':
        case 'LmTextArea':
        case 'LmPassword':
          builderComponentToReturn = 'LmTextNumberEditorTextAreaPasswordBuilderUi'
          break
        case 'LmPortalTarget':
          builderComponentToReturn = 'LmFormPortalBuilderUi'
          break
        default:
          builderComponentToReturn = componentName + 'BuilderUi'
      }
      return builderComponentToReturn
    },
    selectorElementForm (componentName, elementIndex, called) {
      let formElement = {}

      let formObjectToSendToServerProperty = this.nameFormatter(this.$t(componentName)) + '_' + elementIndex
      if (this.form.formElements.length) {
        let name = this.nameFormatter(this.$t(componentName)) + '_' + elementIndex
        let count = 1
        while (this.form.formElements.some((el, i) => el.formObjectToSendToServerProperty === name && i !== elementIndex)) {
          count === 1 ? name += `_${count}` : name = name.substring(0, name.length - 2) + `_${count}`
          count++
        }
        formObjectToSendToServerProperty = name
      }

      const elementWhereUserEnterDataToSendToServer = {
        id: this.generateId(),
        class: componentName === 'LmTextArea' || componentName === 'LmEditor' || componentName === 'LmUploadFiles' ? 'col-12 col-md-12' : 'col-12 col-md-6',
        componentName,
        formObjectToSendToServerProperty: formObjectToSendToServerProperty
      }
      const propsToGeneratePdf = {
        isHiddenOnPdf: false,
        hasLabelOnPdf: true
      }
      const inputComponentProps = {
        componentProps: {
          label: this.$t(componentName),
          placeholder: this.$t(componentName),
          isVisible: true
        },
        componentPermissions: {
          allowToSee: [],
          allowEdit: []
        }
      }
      switch (componentName) {
        case 'LmTextInput':
        case 'LmEmailInput':
        case 'LmNumberInput':
        case 'LmNumberInputV2':
        case 'LmTextArea':
        case 'LmPassword':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            ...inputComponentProps,
            ...propsToGeneratePdf,
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
        case 'LmUploadFiles':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            componentProps: {
              label: this.$t(componentName),
              isVisible: true,
              duplicateCheck: false,
              dropzoneOptions: {
                url: process.env.VUE_APP_API_URL + 'upload/',
                headers: {
                  'Cache-Control': null,
                  'X-Requested-With': null
                },
                withCredentials: true,
                thumbnailWidth: 150,
                maxFilesize: 5,
                timeout: 120000,
                addRemoveLinks: true,
                maxFiles: null,
                clickable: true
              }
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
        case 'LmImportFromExcel':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            componentProps: {
              label: this.$t(componentName),
              isVisible: true,
              pathForPostRequest: '/'
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
        case 'LmSelect':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            ...propsToGeneratePdf,
            componentProps: {
              label: this.$t(componentName),
              placeholder: this.$t(componentName),
              returnObjectIdName: true,
              isVisible: true,
              options: {
                disabledOption: 'Seleccione una opción',
                content: []
              }
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
        case 'LmRadio':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            ...propsToGeneratePdf,
            componentProps: {
              label: this.$t(componentName),
              placeholder: this.$t(componentName),
              size: 'md',
              isVertical: false,
              variant: 'radio',
              buttonsClass: 'primary',
              isVisible: true,
              options: [],
              defaultValue: ''
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
        case 'LmSuperPowerSelectV2':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            ...propsToGeneratePdf,
            childrenOf: null,
            optionsChildOf: { content: [] },
            componentProps: {
              isVisible: true,
              options: [],
              multiple: false,
              label: this.$t(componentName),
              urlPathFromGetOptions: ''
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
        case 'LmDate':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            ...propsToGeneratePdf,
            componentProps: {
              isVisible: true,
              label: this.$t(componentName),
              placeholder: this.$t(componentName),
              config: {
                dateFormat: 'd-m-Y',
                locale: 'Spanish',
                allowInput: true,
                minDate: null
              }
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
        case 'LmDateTime':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            ...propsToGeneratePdf,
            componentProps: {
              isVisible: true,
              label: this.$t(componentName),
              placeholder: this.$t(componentName),
              config: {
                dateFormat: 'd-m-Y H:i',
                locale: 'Spanish',
                enableTime: true,
                minDate: null
              }
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
        case 'LmLeaFletMap':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            class: 'col-12 col-md-12',
            componentProps: {
              isVisible: true,
              label: 'Dirección',
              placeholder: this.$t(componentName),
              initialPosition: {
                formattedAddress: 'Olivos, Provincia de Buenos Aires, Argentina',
                latLong: [-34.5105515, -58.4963913]
              },
              zoom: 16,
              tile: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
              height: '400px'
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
        case 'LmFormSubtitles':
          formElement = {
            id: this.generateId(),
            class: 'col-12 col-md-12',
            componentName,
            componentProps: {
              isVisible: true,
              text: this.$t('subtitle_placeholder_example')
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
        case 'LmComment':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            class: 'col-12',
            componentProps: {
              isVisible: true,
              comment: 'Este es mi comentario'
            }
          }
          break
        case 'LmPortalTarget':
          formElement = {
            id: this.generateId(),
            class: 'col-12 col-md-6',
            componentName: 'LmPortalTarget',
            componentProps: {
              isVisible: true,
              name: '',
              slim: true
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
        case 'LmFormEmptySpace':
          formElement = {
            id: this.generateId(),
            class: 'col-12 col-md-6',
            componentName,
            componentProps: {
              isVisible: true
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
        case 'LmHtmlContent':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            ...propsToGeneratePdf,
            componentProps: {
              isVisible: true,
              html: '<p>Su contenido</p>'
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
        case 'LmFormSeparator':
          formElement = {
            id: this.generateId(),
            class: 'col-12 mt-3',
            componentName,
            componentProps: {
              isVisible: true
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
        case 'LmColorPicker':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            ...propsToGeneratePdf,
            componentProps: {
              isVisible: true,
              label: this.$t(componentName),
              defaultValue: ''
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
        case 'LmButton':
          formElement = {
            id: this.generateId(),
            class: 'col-auto',
            componentName,
            componentProps: {
              isVisible: true,
              type: 'submit',
              value: this.$t('Save'),
              buttonClass: 'btn-primary',
              icon: '',
              iconPosition: 'left',
              size: 'md',
              requireConfirmation: false,
              confirmationTitle: this.$t('cannot_be_undone'),
              confirmationMessage: this.$t('are_you_sure')
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            },
            actions: {
              click: {
                type: 'submit',
                arguments: {
                  deleteMethod: 'put',
                  logicDeleteProperty: 'deleted',
                  logicDeleteValue: true,
                  path: ''
                },
                params: {}
              }
            }
          }
          break
        case 'LmRepeatFields':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            ...propsToGeneratePdf,
            class: 'col-12 mt-3',
            // Se definen las props que LmFormBuilder le pasará a LmRepeatFields
            componentProps: {
              isVisible: true,
              label: this.$t(componentName),
              initialItems: {},
              // isOnEditMode: this.isOnEditMode,
              buttonText: this.$t('Agregar'),
              labelGroup: '',
              isLabelGroupNumber: true
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break

        case 'LmCheckbox':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            ...propsToGeneratePdf,
            class: 'col-12 col-md-12',
            componentProps: {
              isVisible: true,
              title: this.$t('title'),
              subtitle: this.$t('subtitle'),
              label: this.$t('title'),
              isOnEditMode: this.isOnEditMode,
              buttonText: this.$t('add'),
              labelGroup: '',
              labelSingle: 'Texto del Checkbox',
              type: 'single',
              size: 'md',
              variant: '',
              labelPosition: 'left',
              options: [
              ],
              orientation: 'inline'
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
        case 'LmParticipants':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            ...propsToGeneratePdf,
            class: 'col-12',
            componentProps: {
              label: this.$t(componentName),
              placeholder: this.$t(componentName),
              isVisible: true,
              optionsPath: '/users/all'
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
        case 'LmCustom':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            class: 'col-12',
            componentProps: {
              label: this.$t(componentName),
              placeholder: this.$t(componentName),
              isVisible: true
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
        case 'LmCodeInput':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            ...propsToGeneratePdf,
            class: 'col-12',
            componentProps: {
              label: this.$t(componentName),
              placeholder: this.$t(componentName),
              isVisible: true,
              btnPreview: false,
              pathToPreview: '/',
              variables: [],
              defaultValue: null
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
        case 'LmTreeSelect':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            ...propsToGeneratePdf,
            class: 'col-6',
            componentProps: {
              label: this.$t(componentName),
              placeholder: 'Seleccione una opción',
              disabled: false,
              isVisible: true,
              options: null,
              valueConsistsOf: 'LEAF_PRIORITY',
              multiple: false,
              multipleOriginPaths: false,
              // Se usa en los selectores hijos de otro
              originalPathToGetOptions: null,
              pathToGetOptions: null,
              async: false,
              pathToGetAsyncOptions: null,
              defaultValue: null,
              allSelectedAsDefault: false,
              childrenOf: null
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
        case 'LmEditor':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            ...propsToGeneratePdf,
            class: 'col-12',
            componentProps: {
              disabled: false,
              label: this.$t(componentName),
              placeholder: this.$t(componentName),
              isVisible: true,
              variablesOptions: [],
              defaultValue: null,
              useMentions: false,
              scrollable: false
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
        case 'LmTagsInput':
          formElement = {
            ...elementWhereUserEnterDataToSendToServer,
            ...propsToGeneratePdf,
            class: 'col-12 col-md-6',
            componentProps: {
              label: this.$t(componentName),
              placeholder: this.$t(componentName),
              isVisible: true
            },
            validationsItems: {
              email: false,
              maxLength: null,
              minLength: null
            },
            visibilityDependOnConditions: {
              isActive: false,
              conditions: []
            }
          }
          break
      }

      if (called === 'LmRepeatFieldsBuilderUi') {
        this.form.formElements.push(formElement)
        // Envia form a componentProps.InitialItems de LmFormBuilderUi,
        // que se conecta con LmFormBuilder que luego se conecta con las props de LmRepeatFields.
        // En LmFormBuilderUi, initialItems tiene que estar definido en componentProps, del case 'LmRepeatFields'
        // LmRepeatFields tiene que tener definida la prop initialItems
        this.component.componentProps.initialItems = this.form
      } else {
        this.form.formElements.splice(elementIndex, 1, formElement)
      }
    }
  },
  async created () {
    this.isLoading = true
    try {
      if (process?.env?.VUE_APP_ENABLE_MICROSERVICES_CODIFICATORS === 'yes') {
        const res = await apiCommons.axiosGetWrapper('/codificatorbuilder')
        this.lmSuperPowerSelectV2BuilderUiOptions = _.cloneDeep(res.data.items)
      }
      if (store.getters['session/userInfo'].role === 'Superusuario') {
        const componentsForSuperuser = [
          { value: 'LmComment', text: '🗣 Comentario para el desarrollador' },
          { value: 'LmPortalTarget', text: '🚪 Portal' },
          { value: 'LmCustom', text: '🧠  Custom' }
        ]
        this.generator.selectorElementTypeOptions.content = this.generator.selectorElementTypeOptions.content.concat(componentsForSuperuser)
      }
      // Seteo los componentes como opciones del selector
      const options = await apiCommons.axiosGetWrapper(`/codificator/${this.formComponentsOrigin}`)
      const items = { content: [] }
      for (const opt in options.data.options) {
        items.content.push({
          value: options.data.options[opt].value,
          text: options.data.options[opt].text
        })
      }
      this.componentsOptions.content = items.content
    } catch (error) {
      console.log(error)
      // Si no puedo cargar los componentes del codificador, cargo los hardcodeados
      this.componentsOptions = this.generator.selectorElementTypeOptions
    } finally {
      this.isLoading = false
    }
  }
}
